$(function () {
    'use strict';
    const $setCookiesWrapper = $('.set-cookies-wrapper');
    const $alertPopup = $('.wrapper-alert');

    if ($setCookiesWrapper) {
        const popupId = 'alert-popup-' + $setCookiesWrapper.attr('id');
        const popupCookieValue = getCookie(popupId);

        if (!popupCookieValue) {
            setCookie(popupId, 'true', 30);

            if ($alertPopup) {
                $alertPopup.show();

                $('.close').on('click', function (e) {
                    e.preventDefault();

                    $alertPopup.hide();
                });
            }
        }
    }

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    function getCookie(cname) {
        const name = cname + '=';
        const decodedCookie = decodeURIComponent(document.cookie).split(';');
        for (let i = 0; i < decodedCookie.length; i++) {
            let c = decodedCookie[i];
            if (c) {
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
        }
        return null;
    }

    // Close alert popup on click outside of popup content.
    if ($alertPopup) {
        $($alertPopup).on('click', function (event) {
            var content = $('.content');

            if (
                !content.is(event.target) &&
                content.has(event.target).length === 0
            ) {
                $alertPopup.hide();
            }
        });
    }
});
